/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { PRIMARY_GREY, ERROR_RED } from 'constants/colours';

import InputLabel from '../InputLabel';

const StyledFormikWrapper = styled.div`
  display: ${({ display }) => display || 'block'};
  max-width: ${({ size }) => {
    if (size === 'shortest') return '73px';
    if (size === 'short') return '202px';
    if (size === 'medium') return '358px';
    if (size === 'large') return '474px';
    if (size === 'largest') return '694px';
    return null;
  }};
  margin-bottom: ${({ hasBottomMargin }) => hasBottomMargin && '24px'};
  margin-top: ${({ topMargin }) => topMargin && `${topMargin}px`};
`;
const HelpText = styled.p`
  color: ${PRIMARY_GREY};
  opacity: ${({ disabled }) => disabled && '0.5'};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

const InputError = styled.div`
  margin-top: 8px;
  color: ${ERROR_RED};
  font-size: 12px;
  line-height: 16px;
  width: ${({ width }) => (width ? `${width}` : '100%')};
`;

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  disabled: PropTypes.bool,
  helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  display: PropTypes.string,
  size: PropTypes.oneOf(['shortest', 'short', 'medium', 'large', 'largest', 'full']),
  hasBottomMargin: PropTypes.bool,
  topMargin: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  children: PropTypes.any,
  showAsterisk: PropTypes.bool,
  width: PropTypes.string
};

type FormikWrapperProps = PropTypes.InferProps<typeof propTypes>;

const FormikWrapper: React.FC<React.PropsWithChildren<FormikWrapperProps>> = ({
  id,
  label = null,
  disabled = false,
  helpText = null,
  size = 'full',
  display = 'block',
  hasBottomMargin = true,
  topMargin = null,
  error = null,
  children = null,
  showAsterisk = false,
  width = null
}) => {
  return (
    <StyledFormikWrapper
      id={id}
      display={display}
      size={size}
      hasBottomMargin={hasBottomMargin}
      topMargin={topMargin}
      aria-labelledby={label && id}
    >
      {label && (
        <InputLabel htmlFor={id} disabled={disabled} showAsterisk={showAsterisk}>
          {label}
        </InputLabel>
      )}
      {helpText && <HelpText disabled={disabled}>{helpText}</HelpText>}
      {children}
      {error && <InputError width={width}>{error}</InputError>}
    </StyledFormikWrapper>
  );
};

export default FormikWrapper;
